import moment from "moment";
export var testState = {
    dim_mst_new_status_id: 1,
    dim_mst_payment_type_id: 1,
    dim_mst_price_category_id: 1,
    dim_new_alldernow_emp_id: 4,
    dim_supplier_information_id: 7,
    doc_number: "",
    full_supplier_name: "Supplier Co.",
    full_supplier_address_name: "123 Supplier St., City, Country",
    supplier_phone_number: "+1234567890",
    supplier_nickname: "Supplier Nickname",
    is_one_receiving_point: true,
    dim_warehouse_id: 3,
    refer: "REF-12345",
    dim_mst_discount_type_id: 1,
    discount_value: 10.0,
    total_price_before_discount: 1000.0,
    discount_price: 950.0,
    total_price_after_discount: 900.0,
    total_price_product_no_vat: 800.0,
    total_price_product_zero_vat: 0.0,
    total_price_product_seven_vat: 700.0,
    total_price_vat: 50.0,
    grand_total_price: 1050.0,
    remark: "Handle with care.",
    doc_issue_date: "2024-05-01T12:00:00Z",
    delivery_date: "2024-05-10T12:00:00Z",
    delivery_time: "14:15",
    is_sort_manual: true,
    products: [],
    dim_new_item_pr_sorts: []
};
export var initState = {
    dim_mst_new_status_id: "",
    dim_new_purchase_req_id: "",
    dim_mst_payment_type_id: "",
    dim_mst_price_category_id: 2,
    dim_new_alldernow_emp_id: "",
    dim_supplier_information_id: "",
    doc_number: "",
    pr_doc_number_ref: "",
    full_supplier_name: "",
    full_supplier_address_name: "",
    supplier_phone_number: "",
    supplier_nickname: "",
    is_one_receiving_point: true,
    dim_warehouse_id: "",
    refer: "",
    dim_mst_discount_type_id: 1,
    discount_value: 0,
    total_price_before_discount: 0,
    discount_price: 0,
    total_price_after_discount: 0,
    total_price_product_no_vat: 0,
    total_price_product_zero_vat: 0,
    total_price_product_seven_vat: 0,
    total_price_vat: 0,
    grand_total_price: 0,
    remark: "",
    doc_issue_date: moment(new Date()).format("YYYY-MM-DD"),
    delivery_date: "",
    delivery_time: "",
    is_sort_manual: true,
    not_approve_reason: "",
    is_force_success: false,
    force_success_reason: "",
    force_success_at: "",
    products: [],
    dim_new_item_pr_sorts: [],
    dimNewPoSplit: []
};
